import { createTheme } from "@mui/material/styles";

import IBMPlexSans from "../../../fonts/plex-sans/IBMPlexSans-Regular.ttf";

export const theme = createTheme({
  typography: {
    fontFamily: "IBM Plex Sans, 'roboto', sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'IBM Plex Sans';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('IBMPlexSans'), local('IBMPlexSans-Regular'), url(${IBMPlexSans}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
  palette: {
    text: {
      primary: "#706868",
    },
    primary: {
      main: "#A19AED",
    },
    info: {
      main: "#94e083",
    },
    secondary: {
      main: "#EEC373",
    },
    error: {
      main: "#e36e64",
    },
  },
});
